<template lang="es">
  <div class="completo ">
        <v-img class='selector' :src="value == 1?require('./right.png'):require('./left.png')" @click="getIsPlayMode?cambioManualDeValor():null"></v-img>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
	name: "KoioteSelector",
	props: {
		myProps: Object,
		h: Number,
		w: Number
	},
	methods: {
		async cambioManualDeValor() {
			console.log("Cambioooooooo");
			if (typeof this.myProps.customizables.plc == "number" && this.myProps.customizables.variable != null) {
				let plc = this.getConnections.find(e => e.id == this.myProps.customizables.plc)
				console.log('plc');
				console.log(plc);
				if (plc) {
					let nuevaVariable = this.$splitVariable(this.myProps.customizables.variable)
					let variable = plc.variables.find(e => e.number == nuevaVariable.numbers)
					let existsInNodered = this.flows.find(e => e.type == 'mqtt in' && e.topic == `PLC${plc.id}_write`)
					//si no existen los nodos en el cliente los añadimos
					if (existsInNodered !== undefined)
						await this.addOmronWritingNodes(plc)
					if (variable && variable.type == 'BIT') {
						let valor = this.myProps.customizables.value == 0 ? 1 : 0
						console.log("Lo cambio a " + valor);
						this.$emit('cambioValor', { id: this.myProps.id_draggable, value: valor })
						let functionName = plc.type.replace(' ', '') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
						functionName = 'writeBitIn' + functionName
						this[functionName](this.myProps.customizables, valor)
					} else {
						console.log("No existe esa variable en ese plc");
					}
				} else {
					console.log("Ese plc no esta conectado en nodered")
				}
			} else {
				console.log("No tengo plc o variable");
			}
		}
	},//fin de los métodos

	computed: {
		...mapState('nodered', ['message', 'flows', 'ListOfmessages']),
		...mapState(['component_selected']),
		...mapGetters('nodered', ['getConnections']),
		...mapGetters(['getIsPlayMode']),
		bufferPos() {
			if (this.myPlc) {
				let plcType = this.myPlc.type.replace(' ', '') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
				let functionName = 'calculate' + plcType + 'BufferPos'
				return this[functionName](this.myProps.customizables, this.myPlc)
			}
		},
		dataType() {
			if (this.myPlc) {
				let plcType = this.myPlc.type.replace(' ', '') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
				let functionName = 'calculate' + plcType + 'VarType'
				return this[functionName](this.myProps.customizables, this.myPlc)
			}
		},
		myPlc() {
			if (this.myProps.customizables.topic != "") {
				return this.getConnections.find(e => e.id == this.myProps.customizables.plc)
			}
		},
		ancho() {
			let minimo = Math.min(this.h, this.w)
			if (document.documentElement.clientWidth >= 700)
				return minimo / 2
			else
				return minimo / 4
		},

		value() {
			let miMensaje = this.ListOfmessages.find(a => a.topic == this.myProps.customizables.topic)
			if (miMensaje) {
				if (this.myPlc && Object.keys(this.myPlc).length > 0) {
					let functionName = this.myPlc.type.replace(' ', '') // quitamos el espacio del tipo de PLC y ejecutamos la funcion
					functionName = 'readValueFrom' + functionName
					return this[functionName](miMensaje, this.myProps.customizables, this.bufferPos, this.dataType, this.myPlc)
				}
			} else {
				// console.log('No hay mensaje de ese topic :(');
			}

		},
	},
	watch: {
		value() {
			if (this.value != undefined) {
				this.$emit('cambioValor', { id: this.myProps.id_draggable, value: this.value })
			}
		},
	}
};
</script>
<style>
/* .completo {
 height: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 backdrop-filter: blur(5px);
} */
.selector {
	cursor: pointer;
}

#value1-value-label {
	margin: 0;
	padding: 0;
}


/* @media screen and (max-width: 600px) {
 .completo {
   position:relative;
   width:100%;
 }
} */

/* @media screen and (min-width: 1200px) {
 .completo {
   font-size: 6em; 
 }
} */
</style>